// extracted by mini-css-extract-plugin
module.exports = {"industryOverview":"industryOverview-wya6Du5NGNAlrd4Yk-jei","header":"header-18MRF9mc2aImNX9flznrBj","star":"star-3FYz9E4XSbxxOf6YABLVXG","title":"title-SBbf4BhEwdZeVFtlNW3Cb"};